import {Device} from "../../common/ts/types/Device";

export function isDesktopDevice(device: string) {
    return device.toUpperCase() === Device.DESKTOP;
}

export function isMobileDevice(device: string) {
    return device.toUpperCase() === Device.MOBILE;
}